import React, { useEffect, useState } from 'react';
import { MdNotificationsActive } from 'react-icons/md';
import Typography from '@ui/Typography';
import OrgType from '@/constants/orgType.constant';
import { useIsCommunityAdmin } from '@/hooks/useUser';

function PostNotify(props) {
  const { postType, orgType, orgId } = props;

  const isAdmin = useIsCommunityAdmin();

  const [nonProfitFollowers, setNonProfitFollowers] = useState(0);
  const [companyUsers, setCompanyUsers] = useState(0);

  const fetchAllNonProfitFollowers = async (nonProfitId) => {
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_API_HOST}/v1/public/non-profits/${nonProfitId}/all-followers`,
    );

    if (res.ok) {
      const { data } = await res.json();
      setNonProfitFollowers(data?.followers?.length);
    }
  };

  const fetchAllCompanyUsers = async (companyId) => {
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_API_HOST}/v1/public/companies/${companyId}/all-users`,
    );

    if (res.ok) {
      const { data } = await res.json();
      setCompanyUsers(data?.all?.length);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (OrgType.NonProfit === orgType) {
        fetchAllNonProfitFollowers(orgId);
      } else {
        fetchAllCompanyUsers(orgId);
      }
    };

    if (orgId) {
      fetchData();
    }
  }, [postType, orgType, orgId]);

  if (!isAdmin) {
    return null;
  }

  return (
    <div className="flex items-center">
      <MdNotificationsActive className="pr-2 text-primary" size={26} />
      <Typography variant="h5" color="textSecondary">
        This will send email notifications to{' '}
        {OrgType.NonProfit === orgType ? nonProfitFollowers : companyUsers}{' '}
        {OrgType.NonProfit === orgType ? 'supporters' : 'users'}
      </Typography>
    </div>
  );
}

export default PostNotify;
